import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[StatusFlows SetFilter] Action',
  ResetFilter: '[StatusFlows ResetFilter] Action',
}

const initialStatusFlowsState: IStatusFlowsState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IStatusFlowsState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-StatusFlows', whitelist: ['filter']},
  (
    state: IStatusFlowsState = initialStatusFlowsState,
    action: ActionWithPayload<IStatusFlowsState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialStatusFlowsState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
